module.exports = __webpack_public_path__ + "static/goldSilver-bf610ea925a6c669ed0f9f6b630976ab.svg";